import React, { useState, useEffect } from 'react';
import { Edit as ReactAdminEdit, ListButton, ShowButton, useEditContext, useResourceDefinition, useTranslate } from 'react-admin';

import CardActions from '../layout/CardActions';
import Breadcrumb from '../layout/Breadcrumb';

const EditActions = ({ className, children, breadcrumb }) => {
	const { resource, record } = useEditContext();
	const { hasList, hasShow } = useResourceDefinition({ resource });
	const [icon, setIcon] = useState(null);
	const translate = useTranslate();

	useEffect(() => {
		async function getIcon() {
			try {
				const moduleResource = await import(`../../${resource}`);
				if (moduleResource?.default?.icon) {
					setIcon(<moduleResource.default.icon />);
				}
			} catch (e) {
				console.error(e);
			}
		}

		if (resource) {
			getIcon();
		}
	}, [resource]);

	const breadcrumbPath = [
		{ url: `/${resource}`, title: translate(`resources.${resource}.name`, { smart_count: 2, _: resource }), isActive: false, icon },
		{
			url: (record && hasShow) ? `/${resource}/${record.id}/show` : '',
			title: record ? (record.name ? record.name : record.id) : '',
			isActive: !hasShow
		},
		{
			url: record ? `/${resource}/${record.id}` : '',
			title: translate('ra.action.edit'),
			isActive: true
		}
	];

	return (
		<CardActions className={className}>
			<Breadcrumb path={breadcrumb || breadcrumbPath} />
			<div>
				{children}
				{hasList && <ListButton />}
				{hasShow && <ShowButton record={record} />}
			</div>
		</CardActions>
	);
};


const Edit = ReactAdminEdit;

Edit.defaultProps = {
	actions: <EditActions />,
	mutationMode: 'pessimistic'
};

export default Edit;
export { EditActions };